import React from 'react'
import { css } from 'aphrodite'
import { Container, Row, Col } from 'reactstrap'
import Sitemap from '../partials/Sitemap'
import Slideshow from '../partials/Slideshow'

import style from './style'

const sitemapHeader = [
  { url: '/info', title: 'Info' },
  { url: '/about', title: 'About' }
]

export class About extends React.Component {
  render () {
    return [
      <Sitemap key={0} sitemap={sitemapHeader} />,
      <Row key={1} className={css(style.main.section)}>
        <Container>
          <Row>
            <Col xs='6'>
              <Slideshow
                width={`100%`}
                minHeight={`350px`}
                height={`350px`}
                type={`image`}
                timeout={5000}
                slides={[
                  {
                    content: [
                      { type: 'image', src: `/images/home/monitorad.png` }
                    ]
                  },
                  {
                    imageUrl: `/images/about/vpp.png`
                  }
                ]}
              />
            </Col>
            <Col xs='6'>
              <h3 className={css(style.story.h3)}>
                <strong className={css(style.story.strong)}>Where</strong> we
                come from
              </h3>
              <p className={css(style.story.p)}>
                The VPP Gaming Network is an extension from the gaming community
                known as{' '}
                <a
                  className={css(style.story.link)}
                  href='http://www.clanvpp.com'
                >
                  Clan VPP
                </a>, which was born about 12 years ago by a small group of
                friends trying to make a friendly gaming environment.Over the
                years, the community grew and expanded from Counter-Strike to
                various other games including Day Z, Insurgency, and Team
                Fortress 2.
              </p>
              <p className={css(style.story.p)}>
                Like many of our clients,{' '}
                <a
                  className={css(style.story.link)}
                  href='http://www.clanvpp.com'
                >
                  Clan VPP
                </a>{' '}
                needed appropriate funding to run. In most cases, donations from
                it's generous members were the source of funding for the
                community's servers, but in order to accomodate growth and
                expansion, a new source of funding was necessary.
              </p>
              <p className={css(style.story.p)}>
                The process of using ad providers as a source of income can be a
                time-consuming and arduous experience. The{' '}
                <a
                  className={css(style.story.link)}
                  href='http://www.clanvpp.com'
                >
                  VPP Community
                </a>{' '}
                experienced this first-hand, and knew that other communities
                would be going through the same process. In order to share the
                experience and make the process less painful, VPP Gaming Network
                was formed.
              </p>
            </Col>
          </Row>
        </Container>
      </Row>,
      <Row key={2} className={css(style.main.section, style.offer.wrapper)}>
        <Container>
          <h3 className={css(style.offer.h3)}>
            <strong className={css(style.offer.strong)}>What</strong> we offer
          </h3>
          <p className={css(style.offer.p)}>
            VPP Gaming Network has undergone the strenuous process of finding
            the best ad sources for your community. What we offer you is our
            experience with tried and true sources, content, and service. We
            offer what other providers cannot.
          </p>

          <Row>
            <Col xs='12' sm='6'>
              <h4 className={css(style.offer.h4)}>
                <i className={`fa fa-dollar ${css(style.offer.headerIcon)}`} />{' '}
                Premium Rates
              </h4>
              <p className={css(style.offer.p)}>
                Premium CPM Rates that is extremely competitive with other
                providers. We want to give you the best possible rates to
                increase your income. The more you make, the more we make.
              </p>
            </Col>
            <Col xs='12' sm='6'>
              <h4 className={css(style.offer.h4)}>
                <i className={`fa fa-check ${css(style.offer.headerIcon)}`} />{' '}
                Global Content
              </h4>
              <p className={css(style.offer.p)}>
                Content for all countries! It doesn't matter where your servers
                are hosted, we can ensure that you aren't left behind.
              </p>
            </Col>
            <Col xs='12' sm='6'>
              <h4 className={css(style.offer.h4)}>
                <i className={`fa fa-group ${css(style.offer.headerIcon)}`} />{' '}
                Customer Support
              </h4>
              <p className={css(style.offer.p)}>
                Excellent customer service to ensure all of your needs and
                questions are taken care of with a quick response time.
              </p>
            </Col>
            <Col xs='12' sm='6'>
              <h4 className={css(style.offer.h4)}>
                <i
                  className={`fa fa-question ${css(style.offer.headerIcon)}`}
                />{' '}
                Community Advice
              </h4>
              <p className={css(style.offer.p)}>
                For those looking to expand and grow, we share our experience
                with our members. You are part of our community.
              </p>
            </Col>
          </Row>
        </Container>
      </Row>
    ]
  }
}

export default About



// WEBPACK FOOTER //
// ./src/components/About/index.js